module.exports = __webpack_public_path__ + "img/contrata_egresados.c42585af.jpg";